<main class="mediumContainer">
    <div class="d-flex flex-row">
        <button (click)="back()" (keyup.enter)="back()" aria-label="Back" mat-icon-button matTooltip="Back">
            <mat-icon>keyboard_backspace</mat-icon>
        </button>
    </div>
    <div>
        <div class="pt-10">
            <div class="d-flex flex-row flex-space-between">
                <div class="flex-col">
                    <h1 class="my-0">Favourites</h1>
                    <h2 class="my-10 f-16">{{ subtitle }}</h2>
                </div>
            </div>
            @if (loading) {
                <div class="flex-row justify-content-center w-100">
                    <mat-progress-spinner aria-label="Loading favourites" mode="indeterminate"></mat-progress-spinner>
                </div>
            }
            <div>
                @if (!loading) {
                    @if (media.length > 0) {
                        <div class="picsContainer">
                            @for (file of media; track file; let i = $index) {
                                <mat-card
                                        aria-label="View Picture" class="clickable imageCard">
                                    <app-media-display (viewImage)="viewImage(i)" [file]="file"
                                                       [small]="true"></app-media-display>
                                    <mat-card-header (click)="viewImage(i)" (keyup.enter)="viewImage(i)" class="pb-16">
                                        <mat-card-title>{{ file.title  | ellipsis:40 }}</mat-card-title>
                                        @if (file.description) {
                                            <mat-card-subtitle>{{ file.description| ellipsis:65 }}
                                            </mat-card-subtitle>
                                        }
                                    </mat-card-header>
                                </mat-card>
                            }
                        </div>
                    }
                    @if (media.length <= 0) {
                        <div aria-live="polite" class="illustrated-empty-state" role="status">
                            <img src="assets/images/yella.svg" width="193" height="209"
                                 alt="Yellow character waving">
                            @if (loadFailed) {
                                <h2>We couldn't load favourites</h2>
                                <p>Please refresh the page to try again.</p>
                            } @else if (count > 0) {
                                <h2>No favourites on this page</h2>
                                <p>Try an earlier page to see more favourite memories.</p>
                            } @else if (!id) {
                                <h2>No favourites yet</h2>
                                <p>Looks like you have no favourites yet! To favourite a memory, go into an album and click on a memory, then click the heart button.</p>
                            } @else {
                                <h2>No favourites here yet</h2>
                                <p>Looks like this user has no favourites yet!</p>
                            }
                        </div>
                    }
                }
                @if (!loadFailed && count > 0) {
                    <mat-paginator (page)="handlePageEvent($event)" [hidePageSize]='true' [length]="count"
                                   [pageIndex]="page" [pageSize]="this.limit"
                                   aria-label="Select page"></mat-paginator>
                }
            </div>
        </div>
    </div>
</main>
